<template>
  <div class="wrap-trigger-list">
    <!-- Loading -->
    <j-loading-trigger-list v-if="isLoading" />

    <div
      v-if="!isLoading"
      class="triggers"
    >
      <div class="d-flex justify-content-between align-items-center">
        <!-- Add trigger -->
        <div class="add-trigger">
          <p class="label-add-trigger">Trigger Event</p>
          <p
            class="btn-add-trigger"
            @click="toggleModalAdd(true)"
          >
            <i class="fa fa-plus" /> Add
          </p>
        </div>

        <!-- Search triggers -->
        <div
          v-if="masterTriggers.length > 0"
          class="search-trigger"
        >
          <i class="fa fa-search" />
          <input
            v-model="search"
            type="text"
            placeholder="Search Title"
          >
        </div>
      </div>

      <!-- Trigger list -->
      <template v-if="masterTriggers.length > 0">
        <div
          v-for="trigger in triggers"
          :key="trigger.id"
          class="trigger"
        >
          <div class="section-left">
            <img
              :alt="`icon-trigger-${trigger.name}`"
              src="@/assets/automation/trigger.svg"
              width="15"
              height="15"
            >
            <div class="id-trigger">{{ trigger.id }}</div>
            <div class="wrap-event-trigger">
              <div
                :class="`event-${getEvent(trigger).replace('record_', '')}`"
                class="event-trigger"
              >
                {{ getEvent(trigger).replace('_', ' ') }}
              </div>
            </div>
            <p class="name-trigger">{{ trigger.name }}</p>
          </div>

          <div class="section-right">
            <div class="lines" />
            <div
              :class="trigger.is_active ? 'status-on' : 'status-off'"
              class="status-trigger"
            >
              <div class="circle-accent" />
              <span>{{ trigger.is_active ? 'ON' : 'OFF' }}</span>
            </div>
            <div class="lines" />
            <div class="d-flex align-items-center">
              <div class="wrap-btn-action mr-2">
                <div class="info-icon">
                  <i
                    class="fa fa-info"
                    style="cursor: default;"
                  />
                </div>
                <div class="tooltip-component">
                  <div class="wrap-timestamp">
                    <div class="timestamp-type">
                      <p>Created</p>
                      <p>Updated</p>
                    </div>
                    <div class="timestamp">
                      <p>{{ formatFullDateTime(trigger.created_at) }}</p>
                      <p>{{ formatFullDateTime(trigger.updated_at) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wrap-btn-action mr-2">
                <i
                  class="fa fa-external-link"
                  style="margin-top: 6px;"
                  @click="onOpenNewTab(trigger)"
                />
                <div class="tooltip-component">Open new tab</div>
              </div>
              <div class="wrap-btn-action">
                <i
                  class="fa fa-trash"
                  @click="onDeleteTrigger(trigger)"
                />
                <div class="tooltip-component">Delete trigger</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- If data triggers is empty -->
      <p
        v-if="masterTriggers.length === 0"
        class="trigger-not-found"
      >
        {{ isHaveData ? 'All trigger data has been displayed' : 'No triggers registered' }}
      </p>

      <!-- Pagination -->
      <div
        v-if="isHaveData"
        class="custom-pagination"
      >
        <div
          :style="[page === 1 ?
            {'opacity': '0.5', 'cursor': 'not-allowed'} :
          '']"
          class="btn-previous"
          @click="previousPage"
        >
          <i class="fa fa-chevron-left"/>
        </div>
        <div
          :style="[masterTriggers.length < 100 ?
            {'opacity': '0.5', 'cursor': 'not-allowed'} :
          '']"
          class="btn-forward"
          @click="nextPage"
        >
          <i class="fa fa-chevron-right"/>
        </div>
      </div>
    </div>

    <!-- Modal add trigger -->
    <j-modal-add-trigger
      v-if="isShowModalAdd"
      :id="idModalAdd"
      @close-modal="toggleModalAdd(false)"
    />
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
import jwtDecode from 'jwt-decode';
import { mapActions, mapState } from 'vuex';
// Services
import jApiAutomation from '@/services/jApiAutomation';
// Components
import jLoadingTriggerList from '@/components/skeleton-loading/jLoadingTriggerList';
import jModalAddTrigger from '@/views/data-manager/jModalAddTrigger';

export default {
  components: {
    jLoadingTriggerList,
    jModalAddTrigger,
  },

  data() {
    return {
      isLoading: true,
      isHaveData: false,
      isShowModalAdd: false,
      idModalAdd: 'modal-add-trigger',
      masterTriggers: [],
      triggers: [],
      search: '',
      page: 1,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreForm', ['form_data']),
  },

  watch: {
    search(val) {
      if (val) {
        const triggers = JSON.parse(JSON.stringify(this.masterTriggers));
        this.triggers = triggers.filter(
          trigger => trigger.name.toLowerCase().includes(val.toLowerCase()),
        );
      } else {
        this.triggers = this.masterTriggers;
      }
    },
  },

  created() {
    this.getTriggerList();
  },

  methods: {
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading', 'toggleSuccess']),

    async getTriggerList() {
      this.isLoading = true;
      const payload = {
        page: this.page,
        limit: 100,
        sort: { updated_at: -1 },
        filter: {
          company_id: this.session.user.company_id,
          'trigger.type': 'form',
          'trigger.form.form_data_id': this.form_data.id,
        },
      };

      const { data } = await this.getDetailAutomation(payload);
      if (!data.error) {
        this.triggers = data.data;
        this.masterTriggers = data.data;
        if (this.page === 1) this.isHaveData = data.data.length > 0;
      }
      this.isLoading = false;
    },

    toggleModalAdd(status) {
      if (status) {
        this.isShowModalAdd = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalAdd);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalAdd);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isShowModalAdd = false;
        }, 200);
      }
    },

    getEvent(data) {
      let event = '';
      if (data.trigger) {
        switch (data.trigger.type) {
          case 'form':
            event = data.trigger.form ? data.trigger.form.event : '';
            break;
          case 'api':
            event = data.trigger.api ? data.trigger.api.method.toUpperCase() : '';
            break;
          case 'api_v2':
            event = data.trigger.api_v2 ? data.trigger.api_v2.method.toUpperCase() : '';
            break;
          case 'webhook':
            event = data.trigger.webhook ? data.trigger.webhook.method.toUpperCase() : '';
            break;
          case 'webhook_v2':
            event = data.trigger.webhook_v2 ? data.trigger.webhook_v2.method.toUpperCase() : '';
            break;
          case 'event':
            event = data.trigger.event ? data.trigger.event.name : '';
            break;
          default :
            event = '';
        }
      }
      return event;
    },

    onOpenNewTab(trigger) {
      const url = `${window.location.origin}/#/visual-programming/${trigger.id}`;
      window.open(url, '_blank');
    },

    onDeleteTrigger(trigger) {
      const text = 'Are you sure to delete this trigger?';

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const payload = { id: trigger.id };
          this.showLoading();
          const res = await jApiAutomation.deleteAutomation(payload);
          if (res) {
            this.hideLoading();
            if (!res.error) {
              this.page = 1;
              this.toggleSuccess(res.message);
              this.getTriggerList();
            } else {
              this.toggleProblem(res.message);
            }
          }
        }
      });
    },

    previousPage() {
      if (this.page > 1) {
        this.page = this.page - 1;
        this.getTriggerList();
      }
    },

    nextPage() {
      if (this.masterTriggers.length === 100) {
        this.page = this.page + 1;
        this.getTriggerList();
      }
    },

    formatFullDateTime(timestamp) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, '0');
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${day} ${month} ${year} ${hours}:${minutes}:${second}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin font($family, $size, $color) {
  font-family: $family;
  font-size: $size;
  color: $color;
}

.wrap-trigger-list {
  padding: 40px 60px;

  .triggers {
    .add-trigger {
      display: flex;
      align-items: center;

      .label-add-trigger {
        @include font('Poppins-Semibold', 14px, $black-2);
        margin-bottom: 0;
      }
      .btn-add-trigger {
        @include font('Poppins-Semibold', 12px, $primary);
        margin-bottom: 0;
        margin-left: 12px;
        cursor: pointer;
      }
    }

    .search-trigger {
      position: relative;
      width: 250px;

      i {
        position: absolute;
        top: 6px;
        left: 2px;
        color: $black-4;
      }
      input {
        width: 100%;
        background-color: transparent;
        color: $black-2;
        border: none;
        border-bottom: 1px solid #D8D8D8;
        margin-bottom: 1rem;
        padding: 4px 4px 4px 25px;
        transition: all ease 0.4s;

        &:focus {
          outline: none;
          border-color: $primary;
        }
        &::placeholder {
          color: $black-4;;
        }
      }
    }

    .trigger {
      width: 100%;
      height: auto;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $gray-border;
      border-radius: 8px;
      padding: 12px 14px;
      margin-bottom: 15px;

      .section-left {
        display: flex;
        align-items: center;

        img {
          margin-right: 6px;
        }
        .id-trigger {
          width: 90px;
          @include font('Poppins-Semibold', 12px, #BDBDBD);
          border-right: 1px solid $gray-border;
          margin-right: 12px;
          padding-right: 12px;
          white-space: nowrap;
        }
        .wrap-event-trigger {
          width: 144px;
          margin-right: 12px;
          padding-right: 12px;
          border-right: 1px solid $gray-border;

          .event-trigger {
            width: min-content;
            @include font('Poppins-Bold', 12px, #808285);
            padding: 0 5px;
            border: 1px solid black;
            border-radius: 6px;
            text-transform: uppercase;
            white-space: nowrap;

            &.event-created {
              border-color: #808285;
              color: #808285;
            }
            &.event-updated {
              border-color: #444444;
              color: #444444;
            }
            &.event-submitted {
              border-color: #F36F21;
              color: #F36F21;
            }
            &.event-deleted {
              border-color: #D0021B;
              color: #D0021B;
            }
            &.event-approved {
              border-color: #1A85E4;
              color: #1A85E4;
            }
            &.event-exported {
              border-color: #73189D;
              color: #73189D;
            }
            &.event-closed {
              border-color: #0C9C68;
              color: #0C9C68;
            }
            &.event-rejected {
              border-color: #8A0D4F;
              color: #8A0D4F;
            }
          }
        }
        .name-trigger {
          @include font('Poppins-Regular', 14px, #525252);
          margin-bottom: 0;
        }
      }

      .section-right {
        display: flex;
        align-items: center;

        .lines {
          width: 1px;
          height: 18px;
          background-color: $gray-border;
          margin: 0 12px;
        }
        .status-trigger {
          display: flex;
          align-items: center;
          padding: 2px 6px;
          border-radius: 9999px;

          .circle-accent {
            width: 13px;
            height: 13px;
            margin-right: 4px;
            border-radius: 9999px;
          }
          span {
            @include font('Poppins-Bold', 14px, $black);
          }

          &.status-on {
            background-color: #F0F8E5;

            .circle-accent {
              background-color: #61BC50;
            }
            span {
              color: #61BC50;
            }
          }
          &.status-off {
            background-color: #FFEBED;

            .circle-accent {
              background-color: #D0021B;
            }
            span {
              color: #D0021B;
            }
          }
        }
        .wrap-btn-action {
          position: relative;

          .info-icon {
            width: 16px;
            height: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 9999px;
            border: 1px solid $black-2;

            i {
              font-size: 10px;
              margin-right: 1px;
            }
          }
          i {
            font-size: 16px;
            color: $black-2;
            cursor: pointer;
          }
          .tooltip-component {
            position: absolute;
            top: 25px;
            right: 0;
            display: none;
            background-color: white;
            padding: 6px;
            border-radius: 10px;
            box-shadow: 0px 1px 12px rgba(114, 109, 109, 0.25);
            font-family: 'Poppins-Medium';
            font-size: 12px;
            color: #606060;
            white-space: nowrap;
            transition: display ease 0.4s;
            z-index: 1;

            .wrap-timestamp {
              display: grid;
              grid-template-columns: min-content 1fr;
              grid-gap: 4px;

              .timestamp-type {
                p {
                  @include font('Poppins-Semibold', 12px, $gray-1);
                  margin-bottom: 2px;

                  &:last-child {
                    margin-bottom: 0
                  }
                }
              }
              .timestamp {
                p {
                  @include font('Poppins-Regular', 12px, $gray-1);
                  text-align: right;
                  white-space: nowrap;
                  margin-bottom: 2px;

                  &:last-child {
                    margin-bottom: 0
                  }
                }
              }
            }
          }
          &:hover {
            .tooltip-component {
              display: block;
            }
          }
        }
      }
    }

    .trigger-not-found {
      @include font('Poppins-Semibold', 14px, $black);
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
}

@media screen and (max-width: 1400px) {
  .wrap-trigger-list {
    padding: 40px 20px;

    .triggers {
      .trigger {
        .section-right {
          .status-trigger {
            .circle-accent {
              width: 12px;
              height: 12px;
            }
            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .wrap-trigger-list {
    .triggers {
      .trigger {
        .section-left {
          .name-trigger {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data-manager/jFormTrigger.vue